<template>
  <card>
    <svg-plot :config="config">
      <svg-line :data="line" />
      <svg-line :data="line2" />
    </svg-plot>
  </card>
</template>

<script>
import Card from '@/components/charts/dev/Card.vue'
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgLine from '@/components/charts/svg/plot/Line.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    Card,
    SvgPlot,
    SvgLine
  },
  data () {
    return {
      config: {
        grid: {
          vertical: true
        },
        axis: {
          x: [
            { value: 0, label: 'Апр' }, { value: 1, label: 'Май' }, { value: 2, label: 'Июн' },
            { value: 3, label: 'Июл' }, { value: 4, label: 'Авг' }, { value: 5, label: 'Сен' },
            { value: 6, label: 'Окт' }, { value: 7, label: 'Ноя' }, { value: 8, label: 'Дек' },
            { value: 9, label: 'Янв' }, { value: 10, label: 'Фев' }, { value: 11, label: 'Мар' }
          ]
        }
      },
      stack: [
        {
          x: 0,
          top: [{ value: 20, color: colors[0] }, { value: 120, color: colors[1] }],
          bot: [{ value: 80, color: colors[5] }, { value: 20, color: colors[9] }]
        },
        {
          x: 1,
          top: [{ value: 30, color: colors[0] }, { value: 130, color: colors[1] }],
          bot: [{ value: 75, color: colors[5] }, { value: 10, color: colors[9] }]
        },
        {
          x: 2,
          top: [{ value: 40, color: colors[0] }, { value: 140, color: colors[1] }],
          bot: [{ value: 60, color: colors[5] }, { value: 15, color: colors[9] }]
        },
        {
          x: 3,
          top: [{ value: 10, color: colors[0] }, { value: 100, color: colors[1] }],
          bot: [{ value: 30, color: colors[5] }, { value: 30, color: colors[9] }]
        },
        {
          x: 4,
          top: [{ value: 30, color: colors[0] }, { value: 80, color: colors[1] }],
          bot: [{ value: 55, color: colors[5] }, { value: 20, color: colors[9] }]
        },
        {
          x: 5,
          top: [{ value: 50, color: colors[0] }, { value: 90, color: colors[1] }],
          bot: [{ value: 30, color: colors[5] }, { value: 14, color: colors[9] }]
        },
        {
          x: 6,
          top: [{ value: 20, color: colors[0] }, { value: 80, color: colors[1] }],
          bot: [{ value: 60, color: colors[5] }, { value: 30, color: colors[9] }]
        },
        {
          x: 7,
          top: [{ value: 10, color: colors[0] }, { value: 90, color: colors[1] }],
          bot: [{ value: 90, color: colors[5] }, { value: 25, color: colors[9] }]
        },
        {
          x: 8,
          top: [{ value: 20, color: colors[0] }, { value: 75, color: colors[1] }],
          bot: [{ value: 90, color: colors[5] }, { value: 15, color: colors[9] }]
        },
        {
          x: 9,
          top: [{ value: 20, color: colors[0] }, { value: 76, color: colors[1] }],
          bot: [{ value: 70, color: colors[5] }, { value: 40, color: colors[9] }]
        },
        {
          x: 10,
          top: [{ value: 10, color: colors[0] }, { value: 60, color: colors[1] }],
          bot: [{ value: 50, color: colors[5] }, { value: 45, color: colors[9] }]
        },
        {
          x: 11,
          top: [{ value: 20, color: colors[0] }, { value: 55, color: colors[1] }],
          bot: [{ value: 60, color: colors[5] }, { value: 50, color: colors[9] }]
        }
      ],
      line: {
        series: [
          { x: 0, y: 120 }, { x: 1, y: 50 }, { x: 2, y: 40 },
          { x: 3, y: 80 }, { x: 4, y: 90 }, { x: 5, y: 120 },
          { x: 6, y: 60 }, { x: 7, y: 130 }, { x: 8, y: 150 },
          { x: 9, y: 90 }, { x: 10, y: 120 }, { x: 11, y: 100 }
        ],
        style: {
          color: colors[1],
          strokeWidth: 2
        }
      },
      line2: {
        series: [
          { x: 0, y: 90 }, { x: 1, y: 100 }, { x: 2, y: 120 },
          { x: 3, y: 130 }, { x: 4, y: 125 }, { x: 5, y: 120 },
          { x: 6, y: 110 }, { x: 7, y: 90 }, { x: 8, y: 100 },
          { x: 9, y: 110 }, { x: 10, y: 120 }, { x: 11, y: 130 }
        ],
        style: {
          color: colors[3],
          strokeWidth: 2
        }
      }
    }
  }
}
</script>
